import {
  AbilityBuilder,
  createMongoAbility,
  type MongoAbility,
} from '@casl/ability';

import { Action } from '@/authorization/action';
import { Subject } from '@/authorization/subject';

export const MANAGE_PRODUCTION_DECLARATION_ROLE =
  'manage-production-declaration' as const;

export type AppAbility = MongoAbility<
  [(typeof Action)[keyof typeof Action], (typeof Subject)[keyof typeof Subject]]
>;

export function defineAbilityForClientRoles(roles: string[]): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (roles.includes(MANAGE_PRODUCTION_DECLARATION_ROLE)) {
    can(Action.Manage, Subject.ProductionDeclaration);
  }

  return build();
}
